module.exports = __webpack_public_path__ + "img/popup_button8_pre.f7221b57.png";